'use client'

import { AlertCircle, X } from 'lucide-react'
import React from 'react'

import { Button } from '@/components/ui'

export const Alerts = ({ data }: { data: any }) => {
  const [isOpen, setIsOpen] = React.useState(true)

  if (!isOpen) return null

  return (
    <div className="fixed left-0 right-0 top-0 z-[5000] flex w-full items-center gap-3 bg-yellow-400 pl-7 pr-2 py-2.5 text-left text-gray-950">
      <AlertCircle className="size-5" strokeWidth={2} />
      <div className="flex w-full flex-col">
        <span className="text-sm font-medium">
          We've noticed your subscription payment hasn't come through yet.
        </span>
        <span className="text-xs">
          We've kept your access on until {data?.formatted_deactivation_date}.
          Please update your payment to avoid any interruption.
        </span>
      </div>
      <Button variant="ghost" size="sm" onClick={() => setIsOpen(false)} className='hover:bg-transparent'>
        <X className="size-4" strokeWidth={2} />
      </Button>
    </div>
  )
}
